import { GuardianFee } from 'src/apis/guardian/sub-apis/useGuardianFeesService';
import { TStatus } from 'src/apis/finance/finance.interfaces';

export const mockGuardianFees: GuardianFee[] = [
  {
    id: 'fee-1',
    feeType: 'April 2024 Monthly Fee',
    amount: 5000,
    dueDate: '2024-04-30',
    status: 'pending',
    feeComponents: [
      {
        id: 'comp-1',
        componentId: 'lab',
        componentName: 'Lab Fee',
        description: 'Laboratory facilities fee',
        amount: 2000,
        dueDate: '2024-04-30',
        status: TStatus.UNPAID,
        paidAmount: 0,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly lab fee',
        academicYear: 2024,
      },
      {
        id: 'comp-2',
        componentId: 'sports',
        componentName: 'Sports Fee',
        description: 'Sports and recreation fee',
        amount: 1500,
        dueDate: '2024-04-30',
        status: TStatus.UNPAID,
        paidAmount: 0,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly sports fee',
        academicYear: 2024,
      },
      {
        id: 'comp-3',
        componentId: 'library',
        componentName: 'Library Fee',
        description: 'Library access fee',
        amount: 1500,
        dueDate: '2024-04-30',
        status: TStatus.UNPAID,
        paidAmount: 0,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly library fee',
        academicYear: 2024,
      },
    ],
  },
  {
    id: 'fee-2',
    feeType: 'March 2024 Monthly Fee',
    amount: 5000,
    dueDate: '2024-03-31',
    status: 'paid',
    paymentDate: '2024-03-25',
    transactionId: 'TXN-123456',
    feeComponents: [
      {
        id: 'comp-4',
        componentId: 'lab',
        componentName: 'Lab Fee',
        description: 'Laboratory facilities fee',
        amount: 2000,
        dueDate: '2024-03-31',
        status: TStatus.PAID,
        paidAmount: 2000,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly lab fee',
        academicYear: 2024,
      },
      {
        id: 'comp-5',
        componentId: 'sports',
        componentName: 'Sports Fee',
        description: 'Sports and recreation fee',
        amount: 1500,
        dueDate: '2024-03-31',
        status: TStatus.PAID,
        paidAmount: 1500,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly sports fee',
        academicYear: 2024,
      },
      {
        id: 'comp-6',
        componentId: 'library',
        componentName: 'Library Fee',
        description: 'Library access fee',
        amount: 1500,
        dueDate: '2024-03-31',
        status: TStatus.PAID,
        paidAmount: 1500,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly library fee',
        academicYear: 2024,
      },
    ],
  },
  {
    id: 'fee-3',
    feeType: 'February 2024 Monthly Fee',
    amount: 5000,
    dueDate: '2024-02-29',
    status: 'paid',
    paymentDate: '2024-02-20',
    transactionId: 'TXN-123457',
    feeComponents: [
      {
        id: 'comp-7',
        componentId: 'lab',
        componentName: 'Lab Fee',
        description: 'Laboratory facilities fee',
        amount: 2000,
        dueDate: '2024-02-29',
        status: TStatus.PAID,
        paidAmount: 2000,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly lab fee',
        academicYear: 2024,
      },
      {
        id: 'comp-8',
        componentId: 'sports',
        componentName: 'Sports Fee',
        description: 'Sports and recreation fee',
        amount: 1500,
        dueDate: '2024-02-29',
        status: TStatus.PAID,
        paidAmount: 1500,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly sports fee',
        academicYear: 2024,
      },
      {
        id: 'comp-9',
        componentId: 'library',
        componentName: 'Library Fee',
        description: 'Library access fee',
        amount: 1500,
        dueDate: '2024-02-29',
        status: TStatus.PAID,
        paidAmount: 1500,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly library fee',
        academicYear: 2024,
      },
    ],
  },
  {
    id: 'fee-4',
    feeType: 'January 2024 Monthly Fee',
    amount: 5000,
    dueDate: '2024-01-31',
    status: 'overdue',
    feeComponents: [
      {
        id: 'comp-10',
        componentId: 'lab',
        componentName: 'Lab Fee',
        description: 'Laboratory facilities fee',
        amount: 2000,
        dueDate: '2024-01-31',
        status: TStatus.UNPAID,
        paidAmount: 0,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly lab fee',
        academicYear: 2024,
      },
      {
        id: 'comp-11',
        componentId: 'sports',
        componentName: 'Sports Fee',
        description: 'Sports and recreation fee',
        amount: 1500,
        dueDate: '2024-01-31',
        status: TStatus.PARTIAL,
        paidAmount: 750,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly sports fee',
        academicYear: 2024,
      },
      {
        id: 'comp-12',
        componentId: 'library',
        componentName: 'Library Fee',
        description: 'Library access fee',
        amount: 1500,
        dueDate: '2024-01-31',
        status: TStatus.UNPAID,
        paidAmount: 0,
        createdBy: 'admin',
        instituteRef: 'INST-001',
        purpose: 'Monthly library fee',
        academicYear: 2024,
      },
    ],
  },
];
